<template>
  <div>
    <div class="panel-works">
      <h1 class="panel-title">
        <a-icon type="like" theme="twoTone" two-tone-color="#52c41a" />
        精选作品
      </h1>
      <a-row type="flex" :gutter="[24, 24]">
        <a-col v-for="(item, index) in greatWork" :key="index" :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
          <a-card class="work-card">
            <div class="work-cover">
              <a @click="toDetail(item)" target="_blank" class="img-zoom">
                <img v-if="item.workCover" :src="item.workCover_url" />
                <img v-else :src="getCodeIcon(item.codeType)" />
              </a>
            </div>
            <a-row class="work-author">
              <a-col :span="6">
                <a-avatar
                  shape="square"
                  class="avatar"
                  :size="40"
                  :src="item.avatar?item.avatar_url:'/img/avatar.png'"
                   @click="toUserInfo(item)" style="cursor:pointer"
                />
              </a-col>
              <a-col :span="18">
                <span  @click="toUserInfo(item)" style="cursor:pointer">{{ item.realname || item.username }}</span>
              </a-col>
            </a-row>
            <a-divider></a-divider>
            <div class="work-op">
              <a @click="toDetail(item)">{{ item.workName }}</a>
              <a-row type="flex" justify="end">
                <a-col :span="6">
                  <a-icon type="eye" /> {{ item.viewNum }}
                </a-col>
                <a-col :span="6">
                  <a-icon type="like" /> {{ item.starNum }}
                </a-col>
              </a-row>
            </div>
          </a-card>
        </a-col>
      </a-row>
      <a-button class="load-more" type="link" @click="getGreatWork"
        >加载更多……</a-button
      >
    </div>

    <div class="panel-works">
      <h1 class="panel-title">
        <a-icon type="fire" theme="twoTone" two-tone-color="#eb2f96" />
        热门作品
      </h1>
      <a-row type="flex" :gutter="[24, 24]">
        <a-col v-for="(item, index) in hotWork" :key="index" :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
          <a-card class="work-card">
            <div class="work-cover">
              <a @click="toDetail(item)" target="_blank" class="img-zoom">
                <img v-if="item.workCover" :src="item.workCover_url" />
                <img v-else :src="getCodeIcon(item.codeType)" />
              </a>
            </div>
            <a-row class="work-author">
              <a-col :span="6">
                <a-avatar
                  shape="square"
                  class="avatar"
                  :size="40"
                  :src="item.avatar?item.avatar_url:'/img/avatar.png'"
                   @click="toUserInfo(item)" style="cursor:pointer"
                />
              </a-col>
              <a-col :span="18">
                <span  @click="toUserInfo(item)" style="cursor:pointer">{{ item.realname || item.username }}</span>
              </a-col>
            </a-row>
            <a-divider></a-divider>
            <div class="work-op">
              <a @click="toDetail(item)">{{ item.workName }}</a>
              <a-row type="flex" justify="end">
                <a-col :span="6">
                  <a-icon type="eye" /> {{ item.viewNum }}
                </a-col>
                <a-col :span="6">
                  <a-icon type="like" /> {{ item.starNum }}
                </a-col>
              </a-row>
            </div>
          </a-card>
        </a-col>
      </a-row>
      <a-button class="load-more" type="link" @click="getHotWork"
        >加载更多……</a-button
      >
    </div>

    <div class="panel-works">
      <h1 class="panel-title">
        <a-icon type="clock-circle" theme="twoTone" />
        最新作品
      </h1>
      <a-row type="flex" :gutter="[24, 24]">
        <a-col v-for="(item, index) in newWork" :key="index" :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
          <a-card class="work-card">
            <div class="work-cover">
              <a @click="toDetail(item)" target="_blank" class="img-zoom">
                <img v-if="item.workCover" :src="item.workCover_url" />
                <img v-else :src="getCodeIcon(item.codeType)" />
              </a>
            </div>
            <a-row class="work-author">
              <a-col :span="6">
                <a-avatar
                  shape="square"
                  class="avatar"
                  :size="40"
                  :src="item.avatar?item.avatar_url:'/img/avatar.png'"
                   @click="toUserInfo(item)" style="cursor:pointer"
                />
              </a-col>
              <a-col :span="18">
                <span  @click="toUserInfo(item)" style="cursor:pointer">{{ item.realname || item.username }}</span>
              </a-col>
            </a-row>
            <a-divider></a-divider>
            <div class="work-op">
              <a @click="toDetail(item)">{{ item.workName }}</a>
              <a-row type="flex" justify="end">
                <a-col :span="6">
                  <a-icon type="eye" /> {{ item.viewNum }}
                </a-col>
                <a-col :span="6">
                  <a-icon type="like" /> {{ item.starNum }}
                </a-col>
              </a-row>
            </div>
          </a-card>
        </a-col>
      </a-row>
      <a-button class="load-more" type="link" @click="getNewWork"
        >加载更多……</a-button
      >
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import "@/assets/less/animation.css";
import { TENANT_CONFIG, ACCESS_TOKEN } from "@/store/mutation-types";
import { mixinDevice } from "@/utils/mixin.js";
import { getAction } from "@/api/manage";
import { getInfo } from "@/api/login";
import {getEditorUrl, getPlayerUrl, getCodeIcon} from '@/utils/codeTypeUtil.js'

export default {
  name: "Home",
  mixins: [mixinDevice],
  components: {},
  data() {
    return {
      newWork: [],
      greatWork: [],
      hotWork: [],
      page: {
        newWork: 0,
        greatWork: 0,
        hotWork: 0,
      },
    };
  },
  created() {
    this.getNewWork();
    this.getGreatWork();
    this.getHotWork();
  },
  mounted() {},
  methods: {
    getEditorUrl,
    getPlayerUrl,
    getCodeIcon,
    getNewWork() {
      this.page.newWork += 1;
      getAction("/teaching/teachingWork/leaderboard", {
        orderBy: "time",
        pageSize: 8,
        pageNo: this.page.newWork,
      }).then((res) => {
        if (res.success) {
          this.newWork = this.newWork.concat(res.result.records);
          console.log(this.newWork);
          if (res.result.records.length == 0 && this.page.newWork > 1) {
            this.$message.info("已加载完啦！");
          }
        }
      });
    },
    getGreatWork() {
      this.page.greatWork += 1;
      getAction("/teaching/teachingWork/leaderboard", {
        orderBy: "star",
        pageSize: 8,
        pageNo: this.page.greatWork,
      }).then((res) => {
        if (res.success) {
          this.greatWork = this.greatWork.concat(res.result.records);
          if (res.result.records.length == 0 && this.page.greatWork > 1) {
            this.$message.info("已加载完啦！");
          }
        }
      });
    },
    getHotWork() {
      this.page.hotWork += 1;
      getAction("/teaching/teachingWork/leaderboard", {
        orderBy: "view",
        pageSize: 8,
        pageNo: this.page.hotWork,
      }).then((res) => {
        if (res.success) {
          this.hotWork = this.hotWork.concat(res.result.records);
          if (res.result.records.length == 0 && this.page.hotWork > 1) {
            this.$message.info("已加载完啦！");
          }
        }
      });
    },
    toDetail(info) {
      if (info.codeType == 0) {
        this.$router.push("/work/mdView?workId=" + info.id);
      } else {
        this.$router.push("/work/detail?workId=" + info.id);
      }
    },
    toUserInfo(info){
      this.$router.push("/friend/detail?id=" + info.userId)
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  .panel-works {
    margin-bottom: 30px;
  }
  .panel-title {
    font-size: 28px;
    text-shadow: 0 0 3px #000000d1;
  }
  .work-card {
    border: none;

    /deep/.ant-card-body {
      width: 250px;
      height: 280px;
      padding: 0;
      overflow: hidden;
      border-radius: 10px;
      box-shadow: 0px 3px 6px #00000039;
    }
    .ant-divider-horizontal {
      margin: 12px 0;
    }
    .work-cover {
      width: 100%;
      max-height: 150px;
      overflow: hidden;
      img {
        display: block;
        max-width: 100%;
        max-height: 100%;
        margin: auto;
      }
    }
    .work-author {
      padding: 10px 10px 0;
      span {
        line-height: 40px;
      }
    }
    .work-op {
      a {
        color: black;
      }
      a:hover {
        color: #1890ff;
      }
      padding: 0 10px;
    }
  }
  .load-more {
    margin: 10px auto;
    text-align: center;
  }
}
</style>